// extracted by mini-css-extract-plugin
export default {"brandNameContainer":"styles_brandNameContainer__U0mtH","dafitiBlackPositive":"styles_dafitiBlackPositive__irYRj","brandLink":"styles_brandLink__xrUtH"};